module.exports = __webpack_public_path__ + "static/img/application_img2.592e8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application_img2.jpg
// module id = VTB+
// module chunks = 0